import { defineMessages } from 'react-intl'

const messages = defineMessages({
  title: {
    id: 'tenantSettings.verifiedDomains.title',
    description: 'Verified Domains page title',
    defaultMessage: 'Verified Domains',
  },
  domainName: {
    id: 'tenantSettings.verifiedDomains.domainName',
    description: 'Domain name column',
    defaultMessage: 'Domain',
  },
  status: {
    id: 'tenantSettings.verifiedDomains.status',
    description: 'Status column',
    defaultMessage: 'Status',
  },
  verifiedAt: {
    id: 'tenantSettings.verifiedDomains.verifiedAt',
    description: 'Verified-at column',
    defaultMessage: 'Verified',
  },
  statusPending: {
    id: 'tenantSettings.verifiedDomains.statusPending',
    description: 'Pending status chip',
    defaultMessage: 'Pending',
  },
  statusVerified: {
    id: 'tenantSettings.verifiedDomains.statusVerified',
    description: 'Verified status chip',
    defaultMessage: 'Verified',
  },
  statusFailed: {
    id: 'tenantSettings.verifiedDomains.statusFailed',
    description: 'Failed status chip',
    defaultMessage: 'Failed',
  },
  addDomain: {
    id: 'tenantSettings.verifiedDomains.addDomain',
    description: 'Add domain button',
    defaultMessage: 'Add domain',
  },
  verifyNow: {
    id: 'tenantSettings.verifiedDomains.verifyNow',
    description: 'Verify now action',
    defaultMessage: 'Verify now',
  },
  verifyRetryIn: {
    id: 'tenantSettings.verifiedDomains.verifyRetryIn',
    description: 'Verify rate-limited countdown',
    defaultMessage: 'Verify available in {seconds}s',
  },
  remove: {
    id: 'tenantSettings.verifiedDomains.remove',
    description: 'Remove action',
    defaultMessage: 'Remove',
  },
  confirmRemoveTitle: {
    id: 'tenantSettings.verifiedDomains.confirmRemoveTitle',
    description: 'Confirm remove title',
    defaultMessage: 'Remove domain?',
  },
  confirmRemoveBody: {
    id: 'tenantSettings.verifiedDomains.confirmRemoveBody',
    description: 'Confirm remove body',
    defaultMessage: 'Remove {domain}? This cannot be undone.',
  },
  cancel: {
    id: 'tenantSettings.verifiedDomains.cancel',
    description: 'Cancel button',
    defaultMessage: 'Cancel',
  },
  scope: {
    id: 'tenantSettings.verifiedDomains.scope',
    description: 'Scope field',
    defaultMessage: 'Scope',
  },
  scopeTenant: {
    id: 'tenantSettings.verifiedDomains.scopeTenant',
    description: 'Tenant scope',
    defaultMessage: 'Tenant',
  },
  scopeCustomer: {
    id: 'tenantSettings.verifiedDomains.scopeCustomer',
    description: 'Customer scope',
    defaultMessage: 'Customer',
  },
  domainNameRequired: {
    id: 'tenantSettings.verifiedDomains.domainNameRequired',
    description: 'Domain required validation',
    defaultMessage: 'A valid domain is required (e.g. acme.com).',
  },
  tokenInstructions: {
    id: 'tenantSettings.verifiedDomains.tokenInstructions',
    description: 'TXT token instructions',
    defaultMessage:
      'Add this TXT record to your domain’s DNS, then verify. It can take a few minutes to propagate.',
  },
  copy: {
    id: 'tenantSettings.verifiedDomains.copy',
    description: 'Copy button',
    defaultMessage: 'Copy',
  },
  copied: {
    id: 'tenantSettings.verifiedDomains.copied',
    description: 'Copied confirmation',
    defaultMessage: 'Copied',
  },
  doneVerifyLater: {
    id: 'tenantSettings.verifiedDomains.doneVerifyLater',
    description: 'Done, verify later button',
    defaultMessage: 'Done — verify later',
  },
  domainCreated: {
    id: 'tenantSettings.verifiedDomains.domainCreated',
    description: 'Domain created toast',
    defaultMessage: 'Domain added — add the TXT record, then verify.',
  },
  domainRemoved: {
    id: 'tenantSettings.verifiedDomains.domainRemoved',
    description: 'Domain removed toast',
    defaultMessage: 'Domain removed.',
  },
  verifyVerified: {
    id: 'tenantSettings.verifiedDomains.verifyVerified',
    description: 'Verify success toast',
    defaultMessage: 'Domain verified.',
  },
  verifyFailed: {
    id: 'tenantSettings.verifiedDomains.verifyFailed',
    description: 'Verify failed toast',
    defaultMessage: 'Verification failed — the TXT record was not found on both resolvers.',
  },
  verifyStale: {
    id: 'tenantSettings.verifiedDomains.verifyStale',
    description: 'Verify stale toast',
    defaultMessage: 'Domain was modified during verification — please retry.',
  },
})

export default messages
